import axios from 'axios';
import { API_BASE_URL } from './appConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 45000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
